import styled from 'styled-components'
import { Box, Button, Typography, IconButton } from '@mui/material'

export const Container = styled(Box)`
  margin-bottom: 16px;
  margin-top: auto;
  width: 100%;
  display: flex;
  justify-content: center;
`

export const LogoutTrigger = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  padding: 8px;
  border-radius: 8px;

  &:hover {
    background-color: var(--fill-accent-secondary-hover);
  }
`

export const StyledIconButton = styled(IconButton)`
  color: var(--content-neutral-primary) !important;
  padding: 0 !important;
  margin-bottom: 4px !important;
  pointer-events: none;
`

export const LogoutLabel = styled(Typography)`
  color: var(--content-neutral-primary);
  font-size: 10px !important;
  font-weight: 600 !important;
  line-height: 1 !important;
`

export const PopoverContent = styled(Box)`
  padding: 32px 24px 24px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const LogoutButton = styled(Button)`
  background-color: #d32f2f !important;
  color: #fff !important;
  text-transform: none !important;
  font-weight: 600 !important;
  padding: 8px 16px !important;
  border-radius: 8px !important;
  box-shadow: 0 4px 12px rgba(211, 47, 47, 0.2) !important;

  &:hover {
    background-color: #b71c1c !important;
    box-shadow: 0 6px 16px rgba(211, 47, 47, 0.3) !important;
  }
`
